module.exports = __webpack_public_path__ + "static/KreedaAward-1784b5a822ef1566f532143783940a74.png";